import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const idealWeightCalculatorTool: Tool = {
  id: "ideal-weight-calculator",
  name: () => m.iw_tool_name(),
  description: () => m.iw_tool_description(),
  icon: "⚖️",
  basePath: "/ideal-weight-calculator",
  status: "stable",
  tags: ["health", "fitness", "calculator", "ideal-weight-calculator"],
};
